import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Particle } from './Particle.jsx';

export const Confetti = ({ emojis = ['🎉', '🎊', '✨'], isActive, clickPosition }) => {
  console.log('Confetti component render:', {
    emojis,
    isActive,
    clickPosition,
    timestamp: new Date().toISOString()
  });

  const [particles] = useState(() => 
    Array.from({ length: 50 }, (_, i) => ({
      id: i,
      emoji: emojis[i % emojis.length],
      angle: (i / 50) * 360,
      speed: 8 + Math.random() * 6
    }))
  );

  const [defaultPosition, setDefaultPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    // Set default position once we're in the browser
    setDefaultPosition({
      x: window.innerWidth / 2,
      y: window.innerHeight / 2
    });
  }, []);

  // Add fallback click position if not provided
  const position = clickPosition || defaultPosition;

  if (!isActive) return null;

  return (
    <motion.div 
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, delay: 0.5 }}
      className="fixed inset-0 pointer-events-none"
      style={{ zIndex: 99999 }}
    >
      {particles.map(particle => (
        <Particle
          key={particle.id}
          emoji={particle.emoji}
          initialPosition={position}
          angle={particle.angle}
          speed={particle.speed}
        />
      ))}
    </motion.div>
  );
};
